import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "frisbuy-guide-button__images" }
const _hoisted_2 = { class: "frisbuy-guide-button__image-wrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "frisbuy-guide-button__image-wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "frisbuy-guide-button__image-wrapper" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-guide-button__text" }, " Как попасть в галерею ", -1)

import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideButton',
  emits: ["click"],
  setup(__props, { emit: __emit }) {

// Services
const emit = __emit;

function getDomainSubstitute(srcUrl: string): string {
  return DomainSubstitute(srcUrl);
}

function errorImageHandler(e: Event) {
  MediaCatcher(e, 2, widgetTypes.GALLERY);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "frisbuy-guide-button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("img", {
          class: "frisbuy-guide-button__image",
          src: getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102164/1022_asset_картинки для кнопки с гайдом (1)_1757921809.png'),
          alt: "",
          onError: errorImageHandler
        }, null, 40, _hoisted_3)
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("img", {
          class: "frisbuy-guide-button__image",
          src: getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102140/1022_asset_картинки для кнопки с гайдом (2)_1757921860.png'),
          alt: "",
          onError: errorImageHandler
        }, null, 40, _hoisted_5)
      ]),
      _createElementVNode("span", _hoisted_6, [
        _createElementVNode("img", {
          class: "frisbuy-guide-button__image",
          src: getDomainSubstitute('https://www.frisbuy.ru/sld10/files/102158/1022_asset_картинки для кнопки с гайдом (3)_1757921887.png'),
          alt: "",
          onError: errorImageHandler
        }, null, 40, _hoisted_7)
      ])
    ]),
    _hoisted_8
  ]))
}
}

})